var _excluded = ["color"],
  _excluded2 = ["color", "onClear"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { useI18nContext } from '../_hooks/I18n';
import { StyledPill, StyledRemove } from './Pill.styles';
var Remove = /*#__PURE__*/React.forwardRef(function TokenRemove(_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'gray' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  var i18n = useI18nContext();
  return /*#__PURE__*/React.createElement(StyledRemove, _extends({
    ref: ref,
    "aria-hidden": "false",
    "aria-label": i18n.t('core.token.remove'),
    size: "sm",
    $color: color
  }, props));
});

/**

 Pills are used to highlight important information in a list or form such as
 a status.

 @since 10.19.0

 @see [Storybook](https://stories.core.procore.com/?path=/story/core-react_demos-pill--demo)

 @see [Design Guidelines](https://design.procore.com/pill)

 */
export var Pill = /*#__PURE__*/React.forwardRef(function Pill(_ref2, ref) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'gray' : _ref2$color,
    onClear = _ref2.onClear,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(StyledPill, _extends({
    $color: color
  }, props, {
    ref: ref
  }), props.children, onClear && /*#__PURE__*/React.createElement(Remove, {
    color: color,
    onClick: onClear,
    tabIndex: 0
  }));
});
//# sourceMappingURL=Pill.js.map